import createLocationForm from '@shared/local-jobs-location-form';

/**
 * Creates location form with hidden input values appropriately set
 * @param {String} formId
 * @param {Object} aliases Aliases for the names of the hidden fields
 */
export default function createOneClickForm(formId, aliases = {}) {
  let postForm;
  const locationForm = createLocationForm(
    formId,
    Object.assign(aliases, {
      latitude: 'project_geoInfo_lat',
      longitude: 'project_geoInfo_lng',
      vicinity: 'project_geoInfo_vicinity',
      administrative_area: 'project_geoInfo_administrative_area_level_1',
      country: 'project_geoInfo_country',
      full_address: 'project_geoInfo_formatted_address',
    }),
  );

  const fields = locationForm.fields;
  fields.project_type = 'in-person';
  fields.one_click_post = 'true';

  function getForm() {
    if (!postForm) {
      postForm = document.getElementById(formId);
    }
    return postForm;
  }

  function submit() {
    locationForm.attachHiddenFields();
    getForm().submit();
  }

  function setEmail(email) {
    fields.email = email;
  }

  function setNewUserName(newUserName) {
    fields.newusername = newUserName;
  }

  function setNewPassword(newPassword) {
    fields.newuserpasswd = newPassword;
  }

  function setSubCategory(subCategory) {
    fields.jobType = subCategory.name.toLowerCase();
    fields.title = subCategory.name;
    fields.skills = subCategory.jobs.join(',');
  }

  return {
    createHiddenField: locationForm.createHiddenField,
    submit,
    setLocation: locationForm.setLocation,
    attachHiddenFields: locationForm.attachHiddenFields,
    setEmail,
    setNewUserName,
    setNewPassword,
    setSubCategory,
    fields,
  };
}
